import { FormCheckboxGroup } from '@snsw/react-component-library';
import { getLabelText } from 'components/Question/components/getLabelText';
import { QuestionConditionals } from 'components/Question/components/QuestionConditionals';
import { MultiValueQuestionProps, QuestionProps } from 'components/Question/types';
import { ChangeEvent, forwardRef, Ref } from 'react';

type Props = Omit<QuestionProps<string>, 'value' | 'onChange'> & MultiValueQuestionProps;

export const MultiValueQuestion = forwardRef((props: Props, ref: Ref<HTMLInputElement>) => {
  const {
    id,
    name,
    label,
    helpMessage,
    optional,
    onChange,
    conditionalMessages,
    supportingDocuments,

    options,
    errorMessage,
  } = props;

  const value = Array.isArray(props.value) ? props.value : [];
  const labelText = getLabelText(label, optional);

  const optionsWithCheckedState = options.map((o) => ({
    label: o.label,
    value: o.value,
    clarify: o.helpMessage,
    isChecked: Boolean(value?.includes(o.value)),
  }));

  const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
    const { value: toggledValue, checked } = event.target;

    const next = checked ? [...value, toggledValue] : value.filter((prevValue: string) => prevValue !== toggledValue);

    onChange(next, toggledValue);
  };

  return (
    <>
      <FormCheckboxGroup
        id={id}
        name={name}
        legend={labelText}
        helpMessage={helpMessage}
        hasError={errorMessage != null}
        errorMessage={errorMessage}
        options={optionsWithCheckedState}
        onChange={handleChange}
        inputRef={ref}
      />

      <QuestionConditionals<string>
        value={value}
        supportingDocuments={supportingDocuments}
        conditionalMessages={conditionalMessages}
      />
    </>
  );
});
